import ListOfNotches from 'components/ListOfNotches';

import Options from "components/Options";

import GroupedList from "./help/GroupedList";

function ListCard({
    header = null,
    items = {},
    listType = 'default',
    settings = {},
    omniContainer=true,
    selectedDate,

    onSettingChange,
    onClickHandler,
    onEditHandler,
    onDeleteHandler,
    onCancelHandler = null
}) {

    const renderList = (listType) => {
        switch (listType) {
            case 'grouped':
                return (
                    <GroupedList
                        items={items}
                        onClickHandler={onClickHandler}
                    />
                );
            default:
                return (
                    <ListOfNotches 
                        items={items}
                        settings={settings?.items}
                        selectedDate={selectedDate}
                        onClickHandler={onClickHandler}
                        onEditHandler={onEditHandler}
                        onDeleteHandler={onDeleteHandler}
                    />
                );
        }
    }

    // ${onCancelHandler === null ? "mobile-fixed-card" : ""} - onCancelHandler exists only in "add from favorites"
    // in this case display full card
    
    return (
        <div className={`card container-height card-paddings ${onCancelHandler === null ? "mobile-fixed-card" : ""} ${omniContainer ? 'omni-button-container': ''}`}>
            {header && (
                <div className={`card-header ${Object.keys(settings).length > 0 ? "list-header" : "card-header-paddings"} no-background no-border`}>
                    <div className="p-2 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">{header}</h3>

                        <Options
                            settings={settings}
                            onChangeHandler={onSettingChange}
                        />
                    </div>
                </div>
            )}

            {items.length ? (
                <>
                    <div className="card-body overflow-auto p-0">
                        <div className="flex-grow-1 overflow-auto">
                            {renderList(listType)}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="card-body d-flex align-items-center justify-content-center">
                        <div
                            className="text-center"
                        >
                            <p className="text-muted mt-3">No notches</p>
                        </div>
                    </div>
                </>
            )}

            {onCancelHandler && (
                <div className="card-footer card-footer-paddings border-top no-background">
                    <div className="d-flex">
                        <button
                            type="button"
                            className="btn btn-secondary ms-auto"
                            onClick={(e) => {
                                e.preventDefault();

                                onCancelHandler();
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ListCard;
